import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import BrandStory from './components/BrandStory';
import StatsSection from './components/StatsSection';
import ContactSection from './components/ContactSection';

export default function AboutPage() {
  const organizationStructuredData = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '51影视网',
    url: 'https://www.51yingshi.com/',
    description: '51影视网提供免费影视在线观看，高清不卡顿，不缓冲流畅体验，海量视频免费看。',
    email: 'contact@51yingshi.com',
    telephone: '+86-400-888-8888',
    address: {
      '@type': 'PostalAddress',
      streetAddress: '影视产业园区A座1501室',
      addressLocality: '北京',
      addressRegion: '朝阳区',
      addressCountry: 'CN',
    },
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '+86-400-888-8888',
      contactType: 'customer service',
      availableLanguage: ['Chinese'],
      hoursAvailable: [
        {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
          opens: '09:00',
          closes: '21:00',
        },
      ],
    },
  };

  const breadcrumbStructuredData = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: '首页', item: 'https://www.51yingshi.com/' },
      { '@type': 'ListItem', position: 2, name: '关于我们' },
    ],
  };

  const webPageStructuredData = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '关于51影视 - 品牌介绍、口碑与联系方式',
    description: '了解51影视网的品牌故事、发展历程、核心优势及联系方式。51影视网致力于提供免费高清不卡顿的在线影视观看服务。',
    url: 'https://www.51yingshi.com/about',
    isPartOf: {
      '@type': 'WebSite',
      name: '51影视网',
      url: 'https://www.51yingshi.com/',
    },
  };

  return (
    <>
      <ScrollToTop />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationStructuredData) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbStructuredData) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webPageStructuredData) }}
      />
      <Navbar />
      <main className="pt-20 pb-10">
        <nav className="w-full px-4 md:px-6 lg:px-8 pb-4" aria-label="面包屑导航">
          <div className="max-w-[800px] mx-auto flex items-center gap-1.5 text-xs text-foreground-500">
            <a href="/" className="hover:text-primary-500 transition-colors cursor-pointer">首页</a>
            <i className="ri-arrow-right-s-line text-foreground-400"></i>
            <span className="text-foreground-700 font-medium">关于我们</span>
          </div>
        </nav>
        <BrandStory />
        <StatsSection />
        <ContactSection />
      </main>
      <Footer />
    </>
  );
}